import { render } from "./InvioEmail.vue?vue&type=template&id=6953118f"
import script from "./InvioEmail.vue?vue&type=script&lang=js"
export * from "./InvioEmail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__